<div class="wrapper">
  <div class="header">
    <label>{{ header?.label }} {{ header?.value }}</label>
    <label *ngIf="criteria">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="currentColor">
        <path
          d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM6.75 16C6.75 16.41 6.41 16.75 6 16.75C5.59 16.75 5.25 16.41 5.25 16V8C5.25 7.59 5.59 7.25 6 7.25C6.41 7.25 6.75 7.59 6.75 8V16ZM9.75 16C9.75 16.41 9.41 16.75 9 16.75C8.59 16.75 8.25 16.41 8.25 16V15C8.25 14.59 8.59 14.25 9 14.25C9.41 14.25 9.75 14.59 9.75 15V16ZM9.75 12C9.75 12.41 9.41 12.75 9 12.75C8.59 12.75 8.25 12.41 8.25 12V8C8.25 7.59 8.59 7.25 9 7.25C9.41 7.25 9.75 7.59 9.75 8V12ZM12.75 16C12.75 16.41 12.41 16.75 12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16ZM15.75 16C15.75 16.41 15.41 16.75 15 16.75C14.59 16.75 14.25 16.41 14.25 16V12C14.25 11.59 14.59 11.25 15 11.25C15.41 11.25 15.75 11.59 15.75 12V16ZM15.75 9C15.75 9.41 15.41 9.75 15 9.75C14.59 9.75 14.25 9.41 14.25 9V8C14.25 7.59 14.59 7.25 15 7.25C15.41 7.25 15.75 7.59 15.75 8V9ZM18.75 16C18.75 16.41 18.41 16.75 18 16.75C17.59 16.75 17.25 16.41 17.25 16V8C17.25 7.59 17.59 7.25 18 7.25C18.41 7.25 18.75 7.59 18.75 8V16Z"
          fill="#292D32"/>
      </svg>
      {{ criteria }}
    </label>
  </div>
  <div class="content">
    <div *ngFor="let field of parsed_fields" class="field">
      <label>{{ field.label }}</label>
      <p>
        <svg *ngIf="field.icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
             [innerHTML]="field.icon">{{ field.icon }}
        </svg>
        <span *ngIf="field.component">
          <ng-container *ngComponentOutlet="field.component;inputs:{values:field.value,label:field.label,data};"/>
        </span>
        <clipboard *ngIf="!field.component" [value]="field.value"></clipboard>
      </p>
    </div>
  </div>
  <div class="actions">
    <div class="left">
      <!-- bookmark -->
      <svg [ngClass]="{'active': data.bookmarked}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
           fill="currentColor" (click)="toggleBookmark(data)">
        <path fill-rule="evenodd"
              d="M10 2c-1.716 0-3.408.106-5.07.31C3.806 2.45 3 3.414 3 4.517V17.25a.75.75 0 0 0 1.075.676L10 15.082l5.925 2.844A.75.75 0 0 0 17 17.25V4.517c0-1.103-.806-2.068-1.93-2.207A41.403 41.403 0 0 0 10 2Z"
              clip-rule="evenodd"/>
      </svg>

      <!-- document -->
      <svg  *ngIf="document"  (click)="print()"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
      </svg>
      <span *ngIf="document">{{ documents.length }}</span>
    </div>
    <div class="right">
      <badge [color]="status.primary" [accent]="status.accent">{{ status.label }}</badge>
      <a *ngIf="details && id" [relativeTo]="route.parent" [routerLink]="['lookup',id]" [state]="{criteria,batch:data}">View Details »</a>
    </div>
  </div>
</div>
